var _style, _g, _g2, _path, _polygon, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDynamicsValueLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 400",
    style: {
      dominantBaseline: "hanging"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#23B99E;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{fill:url(#SVGID_2_);}\n")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-350)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479,597.5V482.2h43.8c16.3,0,29.6,4.8,40.1,14.5c11.2,10.4,16.8,24.8,16.8,43.1c0,18.5-5.7,33-17,43.5 c-10.3,9.4-23.6,14.2-40,14.2H479z M493.8,585h27.1c3.9,0,7.7-0.3,11.3-0.9s7.5-1.9,11.6-3.9c4.1-2,7.7-4.6,10.7-7.8 c3-3.2,5.5-7.6,7.5-13.2c2-5.6,3-12,3-19.3c0-7.3-1-13.8-3-19.3c-2-5.6-4.5-9.9-7.5-13.2c-3.1-3.2-6.7-5.8-10.8-7.8 c-4.2-2-8-3.3-11.6-4c-3.6-0.7-7.2-1-11-1h-27.1V585z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M624.4,597.5v-43.9l-42.8-71.4H593c3.8,0,6.6,1.6,8.4,4.7l30.4,52.1l30.5-52.1c1.8-3.1,4.6-4.7,8.4-4.7h11.6 l-43.1,71.7v36.7c0,4.6-2.3,6.9-6.9,6.9H624.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M699.9,597.5V482.2h3l79.7,82.2v-75.3c0-4.6,2.3-6.9,6.9-6.9h7.8v115.3h-2.7l-80-82.8v75.9 c0,4.6-2.3,6.9-6.9,6.9H699.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M811.4,597.5l56.7-115.3h3.2L928,597.5h-11.2c-3.8,0-6.5-1.7-8.1-5.2l-7.8-16.7h-62.5l-7.9,16.7 c-1.6,3.5-4.3,5.2-8,5.2H811.4z M844.7,563.2h50.1l-24.9-53.4L844.7,563.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M943.3,597.5V482.2h2.5l54.5,67.1l54.6-67.1h2.5v115.3h-7.5c-4.6,0-6.9-2.3-6.9-6.9V520l-42.7,53.4L958,520 v70.6c0,4.6-2.3,6.9-6.9,6.9H943.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1094.2,597.5c-4.6,0-6.9-2.3-6.9-6.9V482.2h7.9c4.6,0,6.9,2.3,6.9,6.9v108.4H1094.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1184.5,600c-17,0-31.1-5.8-42.4-17.4c-11.2-11.6-16.8-25.8-16.8-42.6c0-16.8,5.6-31,16.8-42.6 c11.2-11.6,25.4-17.4,42.4-17.4c10.5,0,20,2.4,28.6,7.1c8.6,4.7,15.4,11.1,20.5,19.2l-7.8,3.3c-3.6,1.5-6.7,0.7-9.5-2.4 c-8.4-9.1-19-13.7-31.8-13.7c-12.7,0-23.3,4.5-31.7,13.6c-8.4,9-12.7,20-12.7,32.9s4.2,23.9,12.7,32.9c8.4,9,19,13.6,31.7,13.6 c12.6,0,23.2-4.6,31.8-13.8c2.9-3.2,6.1-3.9,9.6-2.2l7.5,3.6c-4.8,8.1-11.4,14.4-19.7,19C1205.5,597.7,1195.8,600,1184.5,600z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1294,599.9c-18.2,0-33.6-5.2-46.3-15.6l4.2-5.1c2.6-3.2,5.8-3.6,9.5-1.2c9.3,5.9,20,8.8,32.1,8.8 c8.7,0,15.5-1.9,20.4-5.8c4.9-3.8,7.3-8.8,7.3-14.8c0-3.4-0.8-6.3-2.4-8.7c-1.6-2.4-4-4.3-7.2-5.9c-3.2-1.5-6.4-2.7-9.6-3.6 c-3.2-0.9-7.3-1.7-12.2-2.6c-11.9-2.1-20.5-4.3-25.5-6.6c-11.6-5.2-17.5-13.7-17.5-25.5c0-4.9,0.9-9.3,2.6-13.2 c1.7-3.9,4-7,6.8-9.5c2.8-2.4,6.1-4.5,9.8-6.1c3.7-1.6,7.5-2.7,11.2-3.4c3.7-0.6,7.5-1,11.4-1c14.8,0,28,4.2,39.7,12.5l-3.8,5.5 c-2.4,3.6-5.6,4.3-9.6,2c-8.2-4.6-17.3-6.9-27.2-6.9c-6.4,0-12.4,1.6-17.9,4.9c-5.5,3.3-8.3,8.2-8.3,14.8c0,3.1,1,5.9,3,8.3 c2,2.4,5.3,4.4,9.9,6.1c4.6,1.7,8.1,2.8,10.3,3.4c2.3,0.6,6.3,1.4,12,2.6c0.9,0.2,1.6,0.4,2.1,0.5c3.4,0.7,6,1.3,7.7,1.7 c1.8,0.4,4.4,1.2,7.8,2.3c3.5,1.1,6.2,2.4,8.3,3.9c2.1,1.5,4.2,3.3,6.5,5.5c2.3,2.2,3.9,4.9,5,8.2c1.1,3.3,1.6,6.9,1.6,10.8 c0,11.1-3.9,19.5-11.8,25.1C1316.2,597.1,1306.2,599.9,1294,599.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1441.2,597.5l-51.8-115.3h10.7c3.9,0,6.6,1.7,8,5.2l34.7,79.1l34.7-79.1c1.5-3.5,4.2-5.2,8-5.2h11 l-52.3,115.3H1441.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1485.2,597.5l56.7-115.3h3.2l56.7,115.3h-11.2c-3.8,0-6.5-1.7-8.1-5.2l-7.8-16.7h-62.5l-7.9,16.7 c-1.6,3.5-4.3,5.2-8,5.2H1485.2z M1518.4,563.2h50.1l-24.9-53.4L1518.4,563.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1617.2,597.5V482.2h7.9c4.6,0,6.9,2.3,6.9,6.9v96.2h57.6c4.6,0,6.9,2.3,6.9,6.9v5.2H1617.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1760.6,599.7c-14.5,0-26.1-4.4-34.9-13.1c-8.8-8.7-13.2-20.3-13.2-34.8v-69.6h7.8c4.6,0,6.9,2.3,6.9,6.9V551 c0,6.7,1.1,12.5,3.4,17.5c2.3,4.9,5.2,8.7,8.7,11.2c3.6,2.5,7.1,4.4,10.6,5.5c3.5,1.1,7.1,1.7,10.6,1.7c3.6,0,7.1-0.6,10.7-1.7 c3.5-1.1,7.1-2.9,10.7-5.5c3.6-2.5,6.5-6.3,8.7-11.2c2.3-4.9,3.4-10.7,3.4-17.5v-61.9c0-4.6,2.3-6.9,6.9-6.9h7.7v69.6 c0,14.6-4.3,26.3-13,34.9C1786.8,595.4,1775.2,599.7,1760.6,599.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1834.9,597.5V482.2h81.3v5.3c0,4.6-2.3,6.9-6.9,7h-59.5v39.7h54v5.6c0,4.6-2.3,6.9-6.9,7h-47.1v38.1h59.5 c4.6,0,6.9,2.3,6.9,6.9v5.7H1834.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 429.6,
    y: 403.3,
    className: "st2",
    width: 4.9,
    height: 273.3
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.9935,
    y1: 534.6439,
    x2: 267.1917,
    y2: 534.6439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06917D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5219,
    style: {
      stopColor: "#2CA68D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EBC9C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M266.3,588.9c-12.6-19.8-34.3-53.7-56.5-88.7c-28.9-45.5-70.7-68.6-124.3-68.6H4v25.5h81.5 c44.9,0,78.5,18.6,102.8,56.7c34.5,54.3,67.7,106.2,67.7,106.2l11.2,17.5L266.3,588.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 266.3208,
    y1: 558.0649,
    x2: 361.0746,
    y2: 558.0649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#06917D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5219,
    style: {
      stopColor: "#2CA68D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3EBC9C"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "266.3,588.9 267.2,637.6 361.1,478.5  "
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.7,490.9c-10.4-0.4-35-0.3-54.2-0.2v-0.1H4v0.3c-0.1,0-0.1,0-0.1,0L4,503.7v131.6L3.9,648c0,0,0.1,0,0.1,0 v0.3h25.5v-0.1c7.9,0,16.8,0.1,25.2,0.1c11.9,0,23-0.1,29.1-0.3c17.6-0.6,74.9-8.2,74.9-78.5S101.3,491.6,83.7,490.9z M82.8,622.6 c-9.9,0.4-34.3,0.3-53.3,0.2V516.2c19-0.1,43.4-0.2,53.3,0.2c23,0.8,50.3,10.7,50.3,53.1C133.1,611.8,105.8,621.7,82.8,622.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDynamicsValueLogo);
export default __webpack_public_path__ + "static/media/DynamicsValueLogo.5c0c6fdac6fac93192dbe503a9caa621.svg";
export { ForwardRef as ReactComponent };